import { toRefs } from 'vue';
import { useGroup } from '../../compositions/component-lib.esm17.js';

//
var script = {
  name: 'VProductGroup',
  props: {
    value: {
      type: [Array, Number, String],
      default: null
    },
    ariaLabel: {
      type: String,
      required: true
    },
    multiple: Boolean
  },
  setup(props, _ref) {
    let {
      emit
    } = _ref;
    const {
      value,
      multiple
    } = toRefs(props);
    useGroup(value, val => emit('input', val), {
      multiple,
      groupName: 'product-group'
    });
    return {};
  }
};
export { script as default };